// No breakpoint on this line!
console.log("This script is also about to be collected.");



//////////////////
// WEBPACK FOOTER
// ./src/collected2.js
// module id = 0
// module chunks = 0